'use client'

/* eslint-disable @typescript-eslint/no-explicit-any */
import type { FetcherResponse } from 'swr/_internal'
import useSWRInfinite, { SWRInfiniteConfiguration, SWRInfiniteResponse } from 'swr/infinite'

import useHttpRequest from '@hooks/useHttpRequest'
import determineCountry from '@lib/helpers/cross-env/determine-country'
import { basePath } from '@lib/constants'

export default function useCustomSWRInfinite<T>(
  key: any,
  fetcher: ((arg: any) => FetcherResponse<T>) | undefined,
  config: SWRInfiniteConfiguration,
): SWRInfiniteResponse<T> {
  const locale = determineCountry()
  const { clientFetch } = useHttpRequest()

  const internalFetcher =
    typeof fetcher !== 'undefined'
      ? fetcher
      : (resource: RequestInfo, init: RequestInit): unknown =>
          clientFetch(`${basePath}/api/${locale}${resource}`.replace(/\/\//g, '/'), init, 'json')

  return useSWRInfinite(key, internalFetcher, { revalidateOnFocus: false, ...config }) as SWRInfiniteResponse<T>
}
